module.exports = __webpack_public_path__ + "img/fuel-special-eq.184b0a32.svg";